module.exports = [{
      plugin: require('/Users/alex/gatsby-alex/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
